export { useCounter, type UseCounterReturn } from "./useCounter";
